import { Select, TextInput } from '@volkswagen-onehub/components-core';
import React, { useState } from 'react';

interface Props {
	label?: string;
	required?: boolean;
	hidePrefijo?: boolean;
	labelPrefijo?: string;
	value?: string;
	prefix?: string;
	phoneNumber?: string;
	onChange?: (data: { prefix: string; phoneNumber: string }) => void;
	onBlur?: () => void;
	disabled?: boolean;
	errorMessage?: string;
}

const prefijos = [
	'+1',
	'+7',
	'+20',
	'+27',
	'+30',
	'+31',
	'+32',
	'+33',
	'+34',
	'+36',
	'+39',
	'+40',
	'+41',
	'+43',
	'+44',
	'+45',
	'+46',
	'+47',
	'+48',
	'+49',
	'+51',
	'+52',
	'+53',
	'+54',
	'+55',
	'+56',
	'+57',
	'+58',
	'+60',
	'+61',
	'+62',
	'+63',
	'+64',
	'+65',
	'+66',
	'+81',
	'+82',
	'+84',
	'+86',
	'+90',
	'+91',
	'+92',
	'+93',
	'+94',
	'+95',
	'+98',
	'+212',
	'+213',
	'+216',
	'+218',
	'+351',
	'+352',
	'+353',
	'+354',
	'+355',
	'+356',
	'+358',
	'+359',
	'+370',
	'+371',
	'+372',
	'+373',
	'+374',
	'+375',
	'+376',
	'+377',
	'+380',
	'+381',
	'+382',
	'+385',
	'+386',
	'+387',
	'+389',
	'+420',
	'+421',
	'+423',
	'+506',
	'+591',
	'+852',
	'+853',
	'+880',
	'+886',
	'+971',
	'+972',
	'+973',
	'+994',
	'+998',
];

export function TelefonoInput(props: Props) {
	const {
		required,
		labelPrefijo,
		prefix,
		phoneNumber: propPhoneNumber,
		onChange,
		onBlur,
		disabled,
		value = '',
	} = props;

	const [selectedPrefix, setSelectedPrefix] = useState(() => {
		if (prefix) return prefix;
		if (value && value.startsWith('+')) {
			const parts = value.split(/(\+\d+)/);
			return parts[1] || '+34';
		}
		return '+34';
	});

	const [phoneNumber, setPhoneNumber] = useState(() => {
		if (propPhoneNumber) return propPhoneNumber;
		if (value && value.startsWith('+')) {
			return value.replace(selectedPrefix, '').trim();
		}
		return '';
	});

	const isValid = phoneNumber.length >= 9;
	const hasContent = phoneNumber.length > 0;
	const appearance = hasContent && !isValid ? 'error' : 'default';

	const isSpanishPrefix = selectedPrefix === '+34';
	const maxLength = isSpanishPrefix ? 9 : 15;

	const handlePrefixChange = (e: React.SyntheticEvent<HTMLSelectElement>) => {
		const newPrefix = e.currentTarget.value;
		setSelectedPrefix(newPrefix);
		onChange?.({ prefix: newPrefix, phoneNumber });
	};

	const handlePhoneChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
		let newPhoneNumber = e.currentTarget.value.replace(/\D/g, '');
		if (newPhoneNumber.length > maxLength) {
			newPhoneNumber = newPhoneNumber.slice(0, maxLength);
		}

		setPhoneNumber(newPhoneNumber);

		if (newPhoneNumber.length >= 9) {
			onChange?.({ prefix: selectedPrefix, phoneNumber: newPhoneNumber });
		} else {
			onChange?.({ prefix: selectedPrefix, phoneNumber: '' });
		}
	};

	return (
		<>
			<style>{`
				.phone-input-container {
					width: 400px;
					max-width: 100%;
				}
				@media (max-width: 599px) {
					.phone-input-container {
						width: 100%;
						box-sizing: border-box;
					}
				}
			`}</style>
			<div style={{ display: 'flex', justifyContent: 'center' }}>
				<div className="phone-input-container" style={{ display: 'flex', gap: '8px' }}>
					<div style={{ minWidth: '80px', flexShrink: 0 }}>
						<Select
							name="phonePrefix"
							label={labelPrefijo ?? 'Prefijo'}
							value={selectedPrefix}
							onChange={handlePrefixChange}
							disabled={disabled}
						>
							{prefijos.map((prefijo) => (
								<option key={prefijo} value={prefijo}>
									{prefijo}
								</option>
							))}
						</Select>
					</div>
					<div style={{ flex: 1, minWidth: '150px' }}>
						<TextInput
							name={'phone'}
							type="text"
							appearance={appearance}
							label={'Teléfono'}
							value={phoneNumber}
							onChange={handlePhoneChange}
							onBlur={onBlur}
							message={'Teléfono incorrecto'}
							maxLength={maxLength}
							required={required}
						/>
					</div>
				</div>
			</div>
		</>
	);
}
